import React, { Component } from "react";
import Api from "Api/Api";
import Store from "redux/store";
import Form, { Item, GroupItem } from "devextreme-react/form";
import Copy from "components/common/Copy";
import DataGrid from "devextreme-react/data-grid";
import Utils from "Utils";
import ReportsFilter from "components/common/ReportsFilter";
import { isAllowed } from "permissions";
import { Permissions } from "permissions/constants";
import { startupStatusMap } from "formFields";

export default class ReportForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableFilter: true,
      type: "investor",
      investors_choice: [],
      startup_choice: [],
      report: null,
      store: this.props.store,
      link: null,
      filters: {},
      disableForm: false,
      formData: {
        investors: [],
        startups: [],
        from_date: null,
        to_date: null,
        type: null,
        store: this.props.store,
      },
    };
    this.reportType = [
      "All Startups",
      "All Investors",
      "Investor",
      "Startup",
      "Investor startup chats",
      "Investor startup data",
      "Investment details",
    ];
    this.limitedTypes = [
      "Investor startup chats",
      "Investor startup data",
      "Investment details",
    ];
    this.generateReport = (e) => {
      e.preventDefault();
      if (this.state.formData.type) {
        Store.dispatch({ type: "toggleLoad" });
        Api.generateReport(this.state.formData, this.state.filters).then(
          (response) => {
            Store.dispatch({ type: "toggleLoad" });
            if (response.status === 200) {
              if (this.state.store) {
                this.setState({ link: response.data });
              } else {
                this.setState({
                  report: response.data.data,
                  link: response.data.link,
                });
              }
            }
          }
        );
      } else {
        Utils.notify("Please select a type", "warning", 1500);
      }
    };
    this.selectboxChanged = (e) => {
      this.setState({ [e.element.id]: e.value });
    };
    this.loadInvestors = (text = "") => {
      let filter = { text };
      Api.getAllInvestor(1, filter).then((response) => {
        if (response.status === 200) {
          this.setState({
            investors_choice: response.data.results,
          });
        }
      });
    };
    this.loadStartups = (text = "") => {
      let filter = { text };
      Api.getAllStartups(1, filter).then((response) => {
        if (response.status === 200) {
          this.setState({
            startup_choice: response.data.results,
          });
        }
      });
    };
    this.tagBoxSearchValueChanged = (e, type) => {
      const inpValue = e.element.getElementsByTagName("input")[0].value;
      if (inpValue.length > 2) {
        if (type === "investor") {
          Utils.debounce(this.loadInvestors(inpValue), 300);
        } else {
          Utils.debounce(this.loadStartups(inpValue), 300);
        }
      }
    };
    this.tagBoxValueChanged = (e, type) => {
      if (e.value.length) {
        const startupLen = this.state.formData.startups.length;
        const investorLen = this.state.formData.investors.length;
        let disableValue = true;
        let filterType = "investor";
        if (!investorLen && startupLen) {
          filterType = "startup";
          disableValue = false;
        } else if (investorLen && !startupLen) {
          disableValue = false;
        } else if (
          (investorLen && startupLen) ||
          (!investorLen && !startupLen)
        ) {
          disableValue = true;
        }
        this.setState({
          disableFilter: disableValue,
          type: filterType,
        });
      }
    };
    this.getFilters = (filters) => {
      this.setState({
        filters,
      });
    };

    this.selectionChanged = (e) => {
      this.setState({
        formData: {
          ...this.state.formData,
          type: e.value,
        },
      });
      let disableFilter = [
        "Investor startup chats",
        "Investor startup data",
      ].includes(e.value);
      this.setState({ disableFilter });
      let disableForm = ["All Investors", "All Startups"].includes(e.value);
      this.setState({
        disableForm,
      });
    };
  }

  componentDidMount() {
    this.loadInvestors();
    this.loadStartups();
  }

  render() {
    return (
      <>
        <form name="report" onSubmit={this.generateReport}>
          <Form formData={this.state.formData}>
            <GroupItem colCount={2}>
              <Item
                dataField="investors"
                editorType="dxTagBox"
                editorOptions={{
                  stylingMode: "underlined",
                  dataSource: this.state.investors_choice,
                  placeholder: "",
                  displayExpr: "username",
                  valueExpr: "primary_email",
                  showSelectionControls: true,
                  searchEnabled: true,
                  searchExpr: "username",
                  onInput: (e) => this.tagBoxSearchValueChanged(e, "investor"),
                  onValueChanged: (e) => this.tagBoxValueChanged(e, "investor"),
                  disabled: this.state.disableForm,
                }}
              />
              <Item
                dataField="startups"
                editorType="dxTagBox"
                editorOptions={{
                  stylingMode: "underlined",
                  dataSource: this.state.startup_choice,
                  valueExpr: "name",
                  placeholder: "",
                  displayExpr: "name",
                  showSelectionControls: true,
                  searchEnabled: true,
                  searchExpr: "name",
                  onInput: (e) => this.tagBoxSearchValueChanged(e, "startup"),
                  onValueChanged: (e) => this.tagBoxValueChanged(e, "startup"),
                  disabled: this.state.disableForm,
                }}
              />
            </GroupItem>
            <GroupItem colCount={3}>
              <Item
                dataField="from_date"
                label={{ text: "From" }}
                editorType="dxDateBox"
                isRequired
                editorOptions={{
                  stylingMode: "underlined",
                  acceptCustomValue: false,
                  dateSerializationFormat: "yyyy-MM-dd",
                  displayFormat: "yyyy-MM-dd",
                  disabled: this.state.disableForm,
                  placeholder: "Default: first day of the month"
                }}
              />
              <Item
                dataField="to_date"
                label={{ text: "To" }}
                editorType="dxDateBox"
                isRequired
                editorOptions={{
                  stylingMode: "underlined",
                  acceptCustomValue: false,
                  dateSerializationFormat: "yyyy-MM-dd",
                  displayFormat: "yyyy-MM-dd",
                  disabled: this.state.disableForm,
                  placeholder: "Default: Current day"
                }}
              />
              <Item
                dataField="type"
                editorType="dxSelectBox"
                isRequired
                editorOptions={{
                  dataSource: isAllowed(Permissions.ALL_REPORT_OPTIONS)
                    ? this.reportType
                    : this.limitedTypes,
                  placeholder: "",
                  stylingMode: "underlined",
                  onValueChanged: this.selectionChanged,
                }}
              />
            </GroupItem>
            <Item
              editorType="dxButton"
              editorOptions={{
                text: "Generate Report",
                useSubmitBehavior: true,
              }}
            />
          </Form>
          <h4>Note</h4>
          <p>Choose future date to get data of a current/required date.</p>
        </form>
        <ReportsFilter applyFilter={this.getFilters} />

        <>
          <div className="report-generated">
            {this.state.store ? (
              this.state.link ? (
                <>
                  <h5>Report Generated</h5>
                  {this.props.download ? (
                    <a href={this.state.link}>{this.state.link}</a>
                  ) : (
                    <Copy
                      content={this.state.link}
                      toBeCopied={this.state.link}
                    />
                  )}
                </>
              ) : null
            ) : this.state.report ? (
              <>
                <h5>Report Generated</h5>
                <a href={this.state.link}>{this.state.link}</a>

                <div className="card">
                  <div className={`card-header card-header-primary`}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div style={{ textTransform: "capitalize" }}>
                          <h4>Report Data</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <DataGrid dataSource={this.state.report} />
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </>
      </>
    );
  }
}
